// @ vendors
const { Promise } = require('es6-promise');

// @ utilities
const { recordProcess, PROC_END, PROC_FAIL} = require('utilities/tagging');

// @ track processes
const { PROC_CHANGE_TIME_LIMIT_FIRM } = require('constants/mortgageRequestProcesses');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const DateHelper = require('utilities/dateHelper');
const { APIPost } = require('utilities/APIRequestHelper');

// @ constants
const {
    MORTGAGE_REQUEST_UPDATE_TARGET_DATE_REQUEST,
    MORTGAGE_REQUEST_UPDATE_TARGET_DATE_SUCCESS,
    MORTGAGE_REQUEST_UPDATE_TARGET_DATE_FAILURE,
    MORTGAGE_REQUEST_STATE_SET_DATE
} = require('constants/actionTypes');

const setTargetDateInProgress = () => ({
    type: MORTGAGE_REQUEST_UPDATE_TARGET_DATE_REQUEST
});

const setTargetDateSuccess = () => ({
    type: MORTGAGE_REQUEST_UPDATE_TARGET_DATE_SUCCESS
});

const setTargetDateFailure = (error) => ({
    type: MORTGAGE_REQUEST_UPDATE_TARGET_DATE_FAILURE,
    data: { error }
});

const updateStateDate = (date) => ({
    type: MORTGAGE_REQUEST_STATE_SET_DATE,
    data: {
        date: date
    }
});

const setTargetDate = (date) => (dispatch, getState) => {
    const formattedDate = !!date ? DateHelper.formatDate(date, 'YYYY-MM-DD') : date;
    const currentState = getState().mortgageRequestTargetDate;
    const isAlreadyFetching = currentState.get('isFetching');

    if (!isAlreadyFetching) {
        const requestData = {
            query: {
              'fechaObjetivo': formattedDate
            }
        };

        dispatch(setTargetDateInProgress());

        return APIPost(dispatch, apiURLBuilder.getURL('mortgageRequestTargetDateUpdate'), requestData)
            .then(() => {
                recordProcess(PROC_CHANGE_TIME_LIMIT_FIRM, PROC_END);
                dispatch(updateStateDate(formattedDate)); // actualiza la fecha en mortgageRequestState
                dispatch(setTargetDateSuccess());
            })
            .catch(response => {
                if (!!response.error) {
                    recordProcess(PROC_CHANGE_TIME_LIMIT_FIRM, PROC_FAIL);
                    dispatch(setTargetDateFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

module.exports = {
    setTargetDate
};
